<label>
  <input (click)="onClick()" [checked]="checked()" type="checkbox"/>
  {{ title() }}
</label>
